import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip'
import {
  formatActivityTime,
  USER_ACTIVITY_HELP_TEXT,
  USER_ACTIVITY_NO_DATA_HINT
} from '@/utils/user-activity'

type UserActivityTimeProps = {
  value?: string | null
  /** what the timestamp means, shown in the tooltip */
  hint?: string
  className?: string
}

/**
 * Relative time ("3 days ago") with the absolute timestamp and semantics in a tooltip.
 * Renders "—" when there is no data.
 */
export const UserActivityTime = ({
  value,
  hint,
  className
}: UserActivityTimeProps) => {
  const { relative, absolute } = formatActivityTime(value)

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={className ?? 'whitespace-nowrap cursor-help'}>
            {relative}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <div className="space-y-1">
            <div className="font-medium">
              {absolute ?? USER_ACTIVITY_NO_DATA_HINT}
            </div>
            {hint && <div>{hint}</div>}
            <div className="text-muted-foreground">
              {USER_ACTIVITY_HELP_TEXT}
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
